<template>
  <v-container
    class="pa-0 max-width-md"
  >
    <v-card
      flat
      tile
      class="pa-3"
    >
      <v-toolbar
        flat
      >
        <v-toolbar-title>
          {{ $t('dtj.title') }} <!-- 公職法律制度的法律解釋及支援服務 -->
        </v-toolbar-title>
      </v-toolbar>

      <v-row>
        <v-col
          cols="12"
        >
          {{ $t('TrainingClient.SaveSuccess') }}
        </v-col>
      </v-row>
    </v-card>
  </v-container>
</template>

<script>

import VuetifyJetValidator from 'vuetify-jet-validator'
import g2eApi from '../../api/hr/g2e'
import boxFileVuex from '../../store/modules/box/file'
import store from '../../store'
import { mapState } from 'vuex'
import { globalModule, boxFileModule } from '../../store/moduleName'
import i18n from '../../i18n'
import { breakSubErrors } from '../../utils/messageUtil'

if (!store.state[boxFileModule]) store.registerModule(boxFileModule, boxFileVuex)

export default {
  components: {

  },
  data: function () {
    const validator = new VuetifyJetValidator()
    return {
      staff: null,
      loading: false,
      name: '',
      entity: ''

    }
  },
  computed: {
    ...mapState({
      files: state => state[boxFileModule].files
    }),

    getStaffName () {
      if (this.staff) {
        return this.$chPtObjData('chinName', this.staff)
      }
      return ''
    },

    getEntityName () {
      if (this.staff) {
        return this.$chPtObjData('entityChinName', this.staff)
      }
      return ''
    }
  },
  watch: {

  },
  created () {

  },
  methods: {

  }
}
</script>
